// Attention list. Mirrors the HTML "What needs attention" card. Each row
// shows a numbered step with its own action button.
//
// TODO(runtime): hydrate from dist/account-workflows.applications[].missing
// once the HTTP read endpoint lands. Button actions open the HubSpot
// Contact properties quick-edit modal (proposed - TODO runtime).
import type { ReactNode } from 'react';
import { JAMIE } from '../../../data/mockData.js';
import type { AttentionItem } from '../mockData.js';

export interface AttentionListProps {
  items: AttentionItem[];
  onRowAction?: (key: string) => void;
}

export function AttentionList({ items, onRowAction }: AttentionListProps): ReactNode {
  return (
    <section className="card attention-card">
      <div className="section-heading">
        <h3>What needs attention</h3>
        <span>{items.length} items in this sample</span>
      </div>
      <div className="attention-list">
        {items.map((item, index) => (
          <div className="attention-row" key={item.key}>
            <span className="step-number">{index + 1}</span>
            <div>
              <strong>{item.title}</strong>
              <p>{item.body}</p>
            </div>
            <button
              className={item.actionVariant === 'primary' ? 'blue-action' : 'outlined'}
              type="button"
              onClick={() => onRowAction?.(item.key)}
            >
              {item.actionLabel}
            </button>
          </div>
        ))}
      </div>
      <div className="owned-next-step">
        <span className="mini-avatar">{JAMIE.initials}</span>
        <div>
          <strong>{JAMIE.fullName} owns the next step</strong>
          <p>Keep the enrollment follow-up open until its status is confirmed.</p>
        </div>
      </div>
    </section>
  );
}
